(function () {
    'use strict';

    var cursor = document.getElementById('cursor');
    var cursorDot = document.getElementById('cursor-dot');
    var cursorX = 0, cursorY = 0;
    var dotX = 0, dotY = 0;

    if (!window.matchMedia('(hover: hover)').matches || !cursor || !cursorDot) return;

    document.addEventListener('mousemove', function (e) {
        cursorX = e.clientX;
        cursorY = e.clientY;
    });

    function animateCursor() {
        dotX += (cursorX - dotX) * 0.2;
        dotY += (cursorY - dotY) * 0.2;

        cursor.style.left = cursorX + 'px';
        cursor.style.top = cursorY + 'px';
        cursorDot.style.left = dotX + 'px';
        cursorDot.style.top = dotY + 'px';

        requestAnimationFrame(animateCursor);
    }
    animateCursor();

    // Standard hover on interactive elements
    document.querySelectorAll('a, button, .btn').forEach(function (el) {
        el.addEventListener('mouseenter', function () { cursor.classList.add('cursor--hover'); });
        el.addEventListener('mouseleave', function () { cursor.classList.remove('cursor--hover'); });
    });

    // "View" cursor on project items and gallery
    document.querySelectorAll('.project-item, .pd-gallery__item').forEach(function (el) {
        el.addEventListener('mouseenter', function () {
            cursor.classList.remove('cursor--hover');
            cursor.classList.add('cursor--view');
        });
        el.addEventListener('mouseleave', function () {
            cursor.classList.remove('cursor--view');
        });
    });
})();
